"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import { useState } from "react";
import { Button } from "../../uiv7/Button";
import { ContentBlock } from "../../ui/ContentBlock";
import { BestSellersBigBlock } from "./BestSellersBigBlock";
import { BestSellersMappedBlocks } from "./BestSellersMappedBlocks";
import { ArrowTitle } from "../../ui/ArrowTitle";
export interface BestSellersProps {
  content: Offer.BestSellers;
  market?: string;
}
export const BestSellers = t0 => {
  const $ = _c(10);
  const {
    content: t1,
    market
  } = t0;
  const {
    headline,
    mobileImage,
    products
  } = t1;
  const [isVisible, setIsVisible] = useState(false);
  const currentHeadline = headline ?? "Shop our Best Sellers";
  let t2;
  if ($[0] !== currentHeadline) {
    t2 = <ArrowTitle headline={currentHeadline} />;
    $[0] = currentHeadline;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isVisible || $[3] !== market || $[4] !== mobileImage || $[5] !== products) {
    t3 = products ? <><div className="relative hidden grid-cols-1 gap-8 pt-6 pb-8 md:grid md:grid-cols-2"><div><BestSellersBigBlock product={products?.[0]} mobileImage={mobileImage} market={market} /></div><div><BestSellersMappedBlocks skipFirst={true} vertical={true} isVisible={isVisible} products={products} market={market} /></div></div><div className={`relative pt-6 md:hidden ${isVisible ? "pb-8" : "pb-16"}`}><BestSellersMappedBlocks isVisible={isVisible} products={products} market={market} />{!isVisible && <div className="absolute -mt-6 w-full"><Button type="button" onClick={() => setIsVisible(!isVisible)} className="bottom-1 mx-auto w-[91%] max-w-full min-w-0 text-lg font-medium uppercase md:w-full md:max-w-[340px]">View more</Button></div>}</div></> : null;
    $[2] = isVisible;
    $[3] = market;
    $[4] = mobileImage;
    $[5] = products;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <ContentBlock className="mt-6 flex max-w-6xl! flex-col justify-center py-10 lg:py-6"><div className="relative mx-6 xl:mx-0">{t2}{t3}</div></ContentBlock>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export { BestSellersShimmer } from "./Shimmer";